
import '../App.css';
import Header from '../components/Header';
import AdvisoryCommittee from '../components/AdvisoryCommittee';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <AdvisoryCommittee/>
    <Footer/>
    </div>
  );
}
export default App;

